import { render, staticRenderFns } from "./addScope.vue?vue&type=template&id=efd70ee8&scoped=true&"
import script from "./addScope.vue?vue&type=script&lang=js&"
export * from "./addScope.vue?vue&type=script&lang=js&"
import style0 from "./addScope.vue?vue&type=style&index=0&id=efd70ee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd70ee8",
  null
  
)

export default component.exports